import React from "react";
import VideoList from "@/components/VideoList";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Videos() {
  usePageMeta(
    "Videos — Okaytwitchy | CHILLWOAH",
    "Official Okaytwitchy music videos and CHILLWOAH films — a cinematic visual gallery. Music videos link the songs and the XRABI pieces worn in them."
  );

  return (
    <div data-testid="videos-page">
      <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-10">
        <p className="font-mono text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-[#F26522]">The Film Catalog</p>
        <h1 className="mt-4 font-display font-extrabold uppercase text-4xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.95]">
          Videos
        </h1>
        <p className="mt-5 max-w-2xl text-lg text-zinc-300">
          Music videos and films from the CHILLWOAH universe — official YouTube premieres, one big frame at a time.
        </p>
        <div className="rule-lux mt-8" aria-hidden="true" />
      </header>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24">
        <VideoList />
      </section>
    </div>
  );
}
